import { useEffect, useState } from "react";

import { TextField, Typography, DocumentList, TextEditor, Checkbox } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";


import { getItemById, getFaqDocumentById } from "../../api/Faq/FaqApi";
import { ContentArea,FormCard,ToolbarTop } from "../../components";
import { Item } from "../../models/Faq";
import { Attachment } from "../../models/Shared/Attachment";
import { faqItemEditUrl, faqItemListRoute } from "../../routes/routes";
import styles from "../SchoolYear/SchoolYearList.module.scss";

export function FaqItemDetails() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();

  const createDefaultItem = (): Item => {
    return {
      id: 0,
      group: { id: 0, name: "" },
      status: true,
    };
  };
  const [item, setItem] = useState<Item>(createDefaultItem());

  useEffect(() => {
    (async () => {
        if (!isNaN(+id) && +id > 0) {
          var result  = (await getItemById(+id));
          if (result) {
            setItem(result);
          }
        }
    })();
  }, [id]);

  const handleGetDocument = (doc: Attachment) => {
    if (doc && doc.id) {
      getFaqDocumentById(doc.id);
    }
  };

  const goBack = () => {
    history.push(faqItemListRoute);
  };
  const handleBackClicked = () => {
      goBack();
  };
  const handleEditClicked = () => {
    history.push(faqItemEditUrl(+id));
  };
  if (!item.answer) return null;
  return (
  <ContentArea>
      <ToolbarTop
        showEdit="show"
        showBack="show"
        onClickEdit={handleEditClicked}
        onClickBack={handleBackClicked}
        pageTitle= {t("common.faq.pageName")}
      ></ToolbarTop>
      <FormCard>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.faq.group")}
              name={"item.groupId"}
              value={item.group?.name}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              label={t("common.faq.question")}
              name={"item.question"}
              value={item.question}
              readonly
              plaintext
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
          <TextEditor 
              label={t("common.faq.answer")}
              initialValue={item.answer}
              handleChange={()=>{}}
              plaintext={true}
            />
          </Col>
        </Row>
        <Row className={styles.rowPaddingMedium}>
          <Col md={12}>
           <Checkbox
              label={t("common.announcement.active")}
              plaintext={true}
              checked={item.status}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Typography variant="medium" component="div" color="light">
              {t("common.announcement.attachments")}
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col>
            <DocumentList
              documents={item.attachments ?? []}
              removable={false}      
              onDocumentClick={handleGetDocument}
            />
          </Col>
        </Row>
      </FormCard>
    </ContentArea>
  );
}


